import ProjectScopeDocActivityComponent from './scope-doc-activity.component'

const ProjectScopeDocActivityModule = angular.module('cdbl.scope-doc-activity', [

])
  .component('cdblProjectScopeDocActivity', ProjectScopeDocActivityComponent)
  .name

export default ProjectScopeDocActivityModule
